import { render, staticRenderFns } from "./CommExtraTables.vue?vue&type=template&id=ac8e490a&"
import script from "./CommExtraTables.vue?vue&type=script&lang=js&"
export * from "./CommExtraTables.vue?vue&type=script&lang=js&"
import style0 from "./CommExtraTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports